import React from "react";

const DownloadReceiptPage = React.lazy(() => import("app/pages/receipts"));
export const noAuthRoutes = [
  {
    path: "/receipt",
    element: <DownloadReceiptPage />,
  },
];
